

const ItineryList = ({ itiListIcon, title, countValue }) => {

  return (
    <>
      <li>
        <img alt="" title="" src={itiListIcon} />
        <p className="first">{title}</p>
        <div className="details" dangerouslySetInnerHTML={{ __html: countValue }}></div>
      </li>
    </>
  )
};

export default ItineryList;      